import { Handler, HasOnSuccess, replaceInChain } from "@insite/client-framework/HandlerCreator";
import { API_URL_CURRENT_FRAGMENT } from "@insite/client-framework/Services/ApiService";
import { CartResult, getCart, GetCartApiParameter } from "@insite/client-framework/Services/CartService";
import { chain, GetCart } from "@insite/client-framework/Store/Data/Carts/Handlers/LoadCurrentCart";

type HandlerType = Handler<
    {
        shouldLoadFullCart?: boolean;
        replaceCart?: boolean;
        getPromotions?: boolean;
        getCartLines?: boolean;
        getCostCodes?: boolean;
    } & HasOnSuccess,
    {
        apiParameter: GetCartApiParameter;
        apiResult: CartResult;
        needFullCart: boolean;
    }
>;

export const GetCartCustom: HandlerType = async props => {
    if (!props.apiParameter.expand) {
        props.apiParameter.expand = ["paymentOptions"];
    } else if (!props.apiParameter.expand.includes("paymentOptions")) {
        props.apiParameter.expand.push("paymentOptions");
    }

    if (props.apiParameter.cartId === API_URL_CURRENT_FRAGMENT) {
        props.apiParameter.additionalQueryStringParameters = {
            ...(props.apiParameter.additionalQueryStringParameters as any),
            _: `${Date.now()}`,
        };
    }

    props.apiResult = await getCart(props.apiParameter);
};

replaceInChain(chain, GetCart, GetCartCustom);
